import { gql } from '@apollo/client'

export const ResetPassword = gql`
    mutation ResetPassword($email: String!, $newPassword: String, $resetToken: String) {
        resetPassword(email: $email, newPassword: $newPassword, resetToken: $resetToken)
    }
`

export default ResetPassword

